export default function () {
  return {
    cidade: {},
    cidades: [],
  };
}
